import styled, { css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'
import { getBasePath } from '../../../utils/miscellaneous-utils'

const BG_IMAGE = getBasePath('/assets/images/background/hidden-gem-bg-pattern.jpg')

export const BannerWrapper = styled.div(
    ({ theme }) => css`
        /* Desktop only — the banner is not shown on mobile. */
        display: none;

        @media (min-width: ${tabletBreakpoint.min}px) {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: ${theme.spacing.xSmall};
            width: 100%;
            /* The price card overlaps the bottom padding, per the Figma frame. Keeping the
               negative margin here means the card is unaffected when the banner is absent. */
            margin: 0 0 -${theme.spacing.large};
            padding: ${theme.spacing.xSmall} ${theme.spacing.xSmall} ${theme.spacing.large};
            background-image: url(${BG_IMAGE});
            background-repeat: repeat;
            border-radius: ${theme.typography.border.radius.xLarge} ${theme.typography.border.radius.xLarge} 0 0;
        }
    `,
)

export const BannerRow = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: flex-start;
        gap: ${theme.spacing.xSmall};
        width: 100%;
    `,
)

export const BannerIcon = styled.img(
    ({ theme }) => css`
        width: ${theme.layout.xSmall};
        height: ${theme.layout.xSmall};
        flex-shrink: 0;
    `,
)

export const TextGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
    word-break: break-word;
`

export const Heading = styled.p(
    ({ theme }) => css`
        margin: 0;
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        font-weight: ${theme.typography.font.lato.weight.semiBold};
        line-height: 1.375rem;
        letter-spacing: -0.1px;
        color: ${theme.colors.tfwBlack99};
    `,
)

export const SubHeading = styled.p(
    ({ theme }) => css`
        margin: 0;
        padding-bottom: ${theme.spacing.xSmall};
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        font-weight: ${theme.typography.font.lato.weight.regular};
        line-height: 1rem;
        color: ${theme.colors.tfwBlack50};
    `,
)
